import { render } from "./AdmCreateSponsor.vue?vue&type=template&id=24e84f02&scoped=true&ts=true"
import script from "./AdmCreateSponsor.vue?vue&type=script&lang=ts"
export * from "./AdmCreateSponsor.vue?vue&type=script&lang=ts"

import "./AdmCreateSponsor.vue?vue&type=style&index=0&id=24e84f02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e84f02"]])

export default __exports__